import { CURRENCIES_WITH_DUAL_PRICING } from '../const';

export function getNewCurrency(currency: string): string {
  const dualPriceElement = CURRENCIES_WITH_DUAL_PRICING.find(
    (item) => item?.currency === currency,
  );

  return dualPriceElement?.newCurrency || '';
}
